// import SModalSelect from 'SharedDir/components/ui/Select/Modal/SModalSelect.vue';
import { App } from 'vue';
import { createYmaps } from 'vue-yandex-maps';

import SBanner from 'SharedComponents/base/Banner/SBanner.vue';
import STable from 'SharedComponents/base/Table/STable.vue';
import STableAction from 'SharedComponents/base/Table/STableAction.vue';
import STableSettings from 'SharedComponents/base/Table/STableSettings.vue';
import SCard from 'SharedComponents/block/SCard.vue';
import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SBtnBack from 'SharedComponents/ui/Button/SBtnBack.vue';
import SBtnClear from 'SharedComponents/ui/Button/SBtnClear.vue';
import SCheckbox from 'SharedComponents/ui/Checkbox/SCheckbox.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import SIconTooltiped from 'SharedComponents/ui/Icon/SIconTooltiped.vue';
import SInput from 'SharedComponents/ui/Input/SInput.vue';
import SInputDate from 'SharedComponents/ui/Input/SInputDate.vue';
import SModal from 'SharedComponents/ui/Modal/SModal.vue';
import SRadio from 'SharedComponents/ui/Radio/SRadio.vue';
import SSkeleton from 'SharedComponents/ui/SSkeleton.vue';
import SSelect from 'SharedComponents/ui/Select/SSelect.vue';
import SToggle from 'SharedComponents/ui/Toggle/SToggle.vue';
import WillBeSoon from 'SharedComponents/ui/WillBeSoon.vue';
import { YANDEX_KEY } from 'SharedDir/constants/app/endpoints';

export function RegisterUIKit(app: App) {
  app.component('SBtn', SBtn);
  app.component('SBtnClear', SBtnClear);
  app.component('SBtnBack', SBtnBack);
  app.component('SInput', SInput);
  app.component('SSelect', SSelect);
  app.component('SRadio', SRadio);
  app.component('SCheckbox', SCheckbox);
  app.component('SToggle', SToggle);
  app.component('SModal', SModal);
  app.component('SIcon', SIcon);
  app.component('SIconTooltiped', SIconTooltiped);
  app.component('STable', STable);
  app.component('STableAction', STableAction);
  app.component('STableSettings', STableSettings);
  app.component('SBanner', SBanner);
  app.component('WillBeSoon', WillBeSoon);
  app.component('SInputDate', SInputDate);
  app.component('SCard', SCard);
  app.component('SSkeleton', SSkeleton);
  app.use(
    createYmaps({
      apikey: YANDEX_KEY,
      lang: 'ru_RU',
    })
  );
  // app.component('SModalSelect', SModalSelect);
}
